module.exports = __webpack_public_path__ + "img/tultepec.58c3da9f.jpg";